var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(agentGroup){return _c('div',{key:agentGroup.id},[_c('div',{class:{
        'hover:bg-gray-50': agentGroup.id !== _vm.agentGroupId,
        'border-l-2 border-blue-700 bg-indigo-50 hover:bg-indigo-100':
          agentGroup.id === _vm.agentGroupId,
      }},[_c('div',{staticClass:"cursor-pointer border-b border-gray-100 px-4"},[_c('group',{attrs:{"agentGroup":agentGroup}})],1)])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }